import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import { AvailableTabs } from '../../shared/models/AvailableTabs';

interface TabPanelProps {
    children?: React.ReactNode;
    index: AvailableTabs;
    value: AvailableTabs;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({
    children,
    value,
    index,
    ...other
}) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`searcher-tabpanel-${index}`}
            aria-labelledby={`searcher-tab-${index}`}
            {...other}
        >
            {value === index && <Box my={5}>{children}</Box>}
        </div>
    );
};
